<!-- close button -->
@if(!hideClose) {
<button class="pos-absolute z-1 right-0 right-2-s top-2-s p-a cursor-pointer button-icon"
        type="button"
        (click)="close()"
        aria-label="Close modal window">
    <i class="icon-close"
       aria-hidden="true"></i>
</button>
}


<div class="flex bg-col-w">
    <!-- left side copy -->
    <div class="center p-a-6 p-r-0 p-r-6-s m-r-6 m-r-0-s"
         [ngClass]="sideImage ? 'w-6 w-12-s' : 'w-12'">
        <!-- modal contents -->
        <ng-content></ng-content>
    </div>
    @if (sideImage) {
    <!-- right side image -->
    <div *ifSize="'!S'"
         class="w-6 pos-relative">
        <img [ratio]="1"
             [dfImage]="sideImage"
             [fill]="true">
    </div>
    }
</div>
